import { render } from "./ServizioListino.vue?vue&type=template&id=730db0e5"
import script from "./ServizioListino.vue?vue&type=script&lang=js"
export * from "./ServizioListino.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__